import { render, staticRenderFns } from "./RecruitInfo.vue?vue&type=template&id=ea763f42&scoped=true&"
import script from "./RecruitInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitInfo.vue?vue&type=script&lang=js&"
import style0 from "../../assets/recruitInfo.css?vue&type=style&index=0&id=ea763f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea763f42",
  null
  
)

export default component.exports